export default __webpack_public_path__ + "static/media/branding-box-image-02.9a310e5d.png";